import {
  Cookie,
  FileText,
  Mail,
  ReceiptText,
  RotateCcw,
  ScrollText,
  ShieldCheck,
} from 'lucide-react';

export const LEGAL_PAGES = [
  {
    slug: 'mentions-legales',
    path: '/mentions-legales',
    labelKey: 'legalPages.names.legalNotice',
    icon: FileText,
  },
  {
    slug: 'confidentialite',
    path: '/confidentialite',
    labelKey: 'legalPages.names.privacy',
    icon: ShieldCheck,
  },
  {
    slug: 'cookies',
    path: '/cookies',
    labelKey: 'legalPages.names.cookies',
    icon: Cookie,
  },
  {
    slug: 'cgu',
    path: '/cgu',
    labelKey: 'legalPages.names.termsOfUse',
    icon: ScrollText,
  },
  {
    slug: 'cgv',
    path: '/cgv',
    labelKey: 'legalPages.names.termsOfSale',
    icon: ReceiptText,
  },
  {
    slug: 'annulation-remboursement',
    path: '/annulation-remboursement',
    labelKey: 'legalPages.names.cancellationRefund',
    icon: RotateCcw,
  },
  {
    slug: 'contact',
    path: '/contact',
    labelKey: 'legalPages.names.contact',
    icon: Mail,
  },
];

export function getLegalPageDefinition(slug) {
  return LEGAL_PAGES.find((page) => page.slug === slug) || null;
}
